export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-page-remove-ccb0e2996597425903980fbeb9e31096.svg";